<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <!-- <template v-if="column.dataIndex == 'remark'">
        <span v-for="(item, index) in JSON.parse(record.remark)" :key="index"
          >{{ item.key }} : {{ item.value }}<br
        /></span>
      </template> -->
      <!-- <template v-if="column.dataIndex == 'status'">
        <span v-if="record.status === 0">未激活</span>
        <span v-if="record.status === 1">激活</span>
      </template> -->
      <template v-if="column.dataIndex == 'status'">
        <a-popconfirm title="确定修改吗?" @confirm="handleOpen(record)">
          <a-switch
            v-model:checked="record.status"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex == 'targetType'">
        <span v-if="record.targetType === '1'">签到</span>
        <span v-if="record.targetType === '2'">浏览</span>
        <span v-if="record.targetType === '3'">分享</span>
      </template>
      <template v-if="column.dataIndex == 'startTime'">
        {{ record.startTime }}~{{ record.endTime }}
      </template>
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="handleEdit(2, record)">查看</a-button>
        <a-button type="link" @click="handleEdit(1, record)">
          编辑
        </a-button>
        <a-popconfirm title="确定删除吗?" @confirm="handleDel(record)">
          <a-button type="link">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
